import { owaComputedFn } from 'owa-computed-fn';
import getStore from '../store/store';
import type ViewType from '../store/schema/ViewType';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import type ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import shouldShowUnstackedReadingPane from './shouldShowUnstackedReadingPane';

export const isReadingPaneStackedView = (listViewType: ReactListViewType | undefined): boolean => {
    // If list view type is message, reading pane is never stacked
    if (!!listViewType && listViewType == 1) {
        return false;
    }

    return isGlobalReadingPaneStackedView();
};

// Mainly exposed for testing
export const isGlobalReadingPaneStackedView: () => boolean = owaComputedFn((): boolean => {
    const store = getStore();

    if (isGlobalFeatureEnabled('rp-momocoSettings') && store.readingPaneViewType != 3) {
        return store.readingPaneViewType != 2;
    } else {
        const globalListViewTypeReact =
            getUserConfiguration()?.UserOptions?.GlobalListViewTypeReact;
        return globalListViewTypeReact != 1 && !shouldShowUnstackedReadingPane();
    }
});
